import {
    faCircleUser,
    faMagnifyingGlass,
    faPrintMagnifyingGlass,
    faGear,
    faFolderMedical,
    faCirclePlus,
} from "@fortawesome/pro-solid-svg-icons";

export const tabIcons = {
    NewAction: faCirclePlus,
    PatientDetails: faCircleUser,
    Topics: faMagnifyingGlass,
    EncounterLookup: faPrintMagnifyingGlass,
    Settings: faGear,
    BedsideShiftReport: faFolderMedical,
} as const;
